<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button-group>
                    <b-button  v-if="Core.Session.AuthUser.can('binder_management_post')" @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouveau classeur')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'BinderTemplateContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/classeur/classeurs/nouveau-classeur')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/classeur/classeurs/nouveau-classeur'))
                }
            },
            list() {
                this.$router.push(window.Core.Definition.getDefinition('/classeur/classeurs'))
            }
        }
    }
</script>
